var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_photo_alternate_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.259,
    height: 54.259,
    viewBox: "0 0 54.259 54.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H54.259V54.259H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61966",
    "data-name": "Path 61966",
    d: "M39.173,13.3v6.76s-4.5.023-4.522,0V13.3H27.869s.023-4.5,0-4.522h6.782V2h4.522V8.782h6.782V13.3ZM32.39,22.347V15.565H25.608V8.782H7.522A4.535,4.535,0,0,0,3,13.3v27.13a4.535,4.535,0,0,0,4.522,4.522h27.13a4.535,4.535,0,0,0,4.522-4.522V22.347ZM7.522,40.433,14.3,31.39l4.522,6.782,6.782-9.043,9.043,11.3Z",
    transform: "translate(3.782 2.522)",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.efeccc2b6268764d0b2bb65cae753949.svg";
export { ForwardRef as ReactComponent };